<template>
  <div class="app-container">
    <div class="main-content">
      <!-- 待排产工单列表 -->
      <div v-show="showAside" class="work-order-list" :style="showAside ?'display: flex;':'display: none'">
        <div class="section-title">
          <i class="el-icon-s-order"/>
          待排产工单列表
        </div>
        <div class="table-container">
          <!-- 补偿容器高度差，主要考虑页面中会出现额外的一些标题啥的，通过这个参数来处理高度差 -->
          <view-table
              id="dragTable"
              ref="viewTable"
              :columns-property="columnsProperty"
              :filter="filter"
              row-key="productionOrderId"
              module="basic"
              :table-select="false"
              :show-page="false"
              :max-height-offset="-60" 
              url="sapProductionOrders/list/unScheduled"
              @reset="resetHandle">
            <template slot="adSearch">
              <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
                <el-form-item label="计划开始日期">
                  <el-date-picker
                      v-model="filter.productStart"
                      type="date"
                      style="width: 200px"
                      value-format="yyyy-MM-dd"
                  />
                </el-form-item>
                <el-form-item label="组装排产">
                  <el-select v-model="filter.assemblePlanDate">
                    <el-option label="是" :value="1"/>
                    <el-option label="否" :value="0"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="测试排产">
                  <el-select v-model="filter.testPlanDate">
                    <el-option label="是" :value="1"/>
                    <el-option label="否" :value="0"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="发料排产">
                  <el-select v-model="filter.feedPlanDate">
                    <el-option label="是" :value="1"/>
                    <el-option label="否" :value="0"/>
                  </el-select>
                </el-form-item>
                <el-form-item label="工单号">
                  <el-input v-model.trim="filter.orders" placeholder="请输入工单编号" clearable/>
                </el-form-item>
                <el-form-item label="物料号">
                  <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
                </el-form-item>
                <el-form-item label="物料名称">
                  <el-input v-model.trim="filter.materialDescription" placeholder="请输入物料名称" clearable/>
                </el-form-item>
                <el-form-item label="工单类型">
                  <el-select v-model="filter.orderType" clearable placeholder="请选择工单类型">
                    <el-option label="全部" value=""/>
                    <el-option label="标准生产订单" value="GK01"/>
                    <el-option label="试制生产订单" value="GK02"/>
                    <el-option label="小批生产订单" value="GK03"/>
                    <el-option label="改制生产订单" value="GK04"/>
                    <el-option label="拆解生产订单" value="GK05"/>
                    <el-option label="呆滞拆解订单" value="GK06"/>
                    <el-option label="外购返修订单" value="GK07"/>
                    <el-option label="研发整改订单" value="ZPP8"/>
                  </el-select>
                </el-form-item>
              </el-form>
            </template>
          </view-table>
        </div>
      </div>
      <el-button
          v-show="showAside1"
          style="padding: 1px"
          :icon="showAside ? 'el-icon-arrow-left' : 'el-icon-arrow-right'"
          @click="handleCollapse"/>
      <el-button
          v-show="showAside"
          style="padding: 1px"
          :icon="showAside1 ? 'el-icon-arrow-right' : 'el-icon-arrow-left'"
          @click="handleCollapse1"/>
      <!-- 已排产工单 -->
      <div class="work-order-list work-order-right-box" :style="showAside1 ? 'display: flex;' : 'display: none'">
        <div class="section-title">
          <i class="el-icon-s-order"/>
          排产订单列表
        </div>
        <div>
          <div class="schedule-date-header">
            <div class="date-navigation">
              <el-date-picker
                  v-model="currentDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择排产日期"
                  style="width: 150px"
                  @change="getData"/>
              <el-select v-model="currentLine" style="width: 120px" placeholder="请选择产线" @change="getData">
                <el-option value="组装线1"/>
                <el-option value="组装线2"/>
                <el-option value="组装线3"/>
                <el-option value="组装线4"/>
                <el-option value="组装线5"/>
                <el-option value="组装线6"/>
                <el-option value="组装线7"/>
                <el-option value="发货前处理线"/>
<!--                <el-option value="发货包装"/>-->
                <el-option value="测试线1"/>
                <el-option value="生产发料"/>
              </el-select>
            </div>
            <div>
              <el-button :loading="submitLoading" type="success" icon="el-icon-check" @click="handleSave">
                保存排产计划
              </el-button>
              <el-button icon="el-icon-refresh-right" @click="getData">重置</el-button>
            </div>
          </div>
          <div v-loading="scheduleLoading">
            <div style="display: flex; justify-content: space-between; align-items: center">
              <span style="width: 80px;">人员安排：</span>
              <el-input v-model="scheduledPerson"/>
            </div>
            <el-table
                id="dragTable2"
                ref="elTable"
                style="margin-top: 5px; max-height: 600px; overflow-y: auto;"
                row-key="productionOrderId"
                :data="scheduledOrders"
                border
                show-summary
                :loading="dragLoading"
                :summary-method="getSummaries">
              <el-table-column type="index" label="序号" align="center" width="100"/>
              <el-table-column v-if="currentLine.includes('组装')" prop="assembleTime" label="组装工时"/>
              <el-table-column v-if="currentLine.includes('测试')" prop="testTime" label="测试工时"/>
              <el-table-column prop="startTime" label="开始时间" align="center" width="80"/>
              <el-table-column prop="endTime" label="结束时间" align="center" width="80"/>
              <el-table-column prop="productionOrderNo" label="工单号" align="center" width="110"/>
              <el-table-column prop="productLayer" label="产品层次" align="center" width="110"/>
              <el-table-column prop="addDate" label="下单日期" align="center" width="140"/>
              <el-table-column prop="quantity" label="工单数量" align="center" width="100"/>
              <el-table-column
                  prop="orderTypeName"
                  label="工单类型"
                  align="center"
                  width="110"
                  show-overflow-tooltip/>
              <el-table-column prop="materialNo" label="物料号" align="center" width="110"/>
              <el-table-column prop="materialDescription" label="物料名称" min-width="140" show-overflow-tooltip/>
              <el-table-column prop="specification" label="规格型号" min-width="140"/>
              <el-table-column label="操作" align="center" width="100" fixed="right">
                <template v-slot="scope">
                  <el-button type="danger" @click="handleRemove(scope)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
    <user-select ref="userSelect" @select="handleUserSelect"/>
  </div>
</template>

<script>
  import Sortable from "sortablejs";
  import ViewTable from "@/components/ViewTable.vue";
  import UserSelect from "@/views/SystemInfo/SystemUser/UserSelect.vue";

  export default {
    name: "ProductionScheduleList",
    components: {UserSelect, ViewTable},
    data() {
      return {
        showAside: true,
        showAside1: true,
        scheduleLoading: false,
        submitLoading: false,
        currentDate: this.$moment().format("YYYY-MM-DD"),
        currentLine: "组装线1",
        dragLoading: false,
        scheduledOrders: [],
        scheduledPerson: "",
        filter: {
          orders: "",
          materialNo: "",
          materialDescription: "",
          orderType: "",
          orderTypeName: "",
          productStart: "",
          sapCustomerNo: "",
          assemblePlanDate: 0,
          testPlanDate: 0,
          feedPlanDate: 0,
        },
        columnsProperty: [
          {
          tooltip: true,
            key: "addDate",
            align: "center",
            width: 160,
          },
          {
          tooltip: true,
            key: "productionOrderNo",
            align: "center",
            width: 110,
          },
          {
          tooltip: true,
            key: "quantity",
            align: "center",
            width: 100,
          },
          {
          tooltip: true,
            key: "saleOrderNo",
            align: "center",
            width: 110,
          },
          {
            key: "orderTypeName",
            align: "center",
            tooltip: true,
            width: 100,
          },
          {
          tooltip: true,
            key: "materialNo",
            align: "center",
            width: 110,
          },
          {
            key: "materialDescription",
            tooltip: true,
            width: 110,
          },
          {
            key: "specification",
            tooltip: true,
            width: 110,
          },
          {
            key: "productLayer",
            tooltip: true,
            width: 110,
          },
          {
          tooltip: true,
            key: "productStart",
            align: "center",
            width: 120,
          },
          {
          tooltip: true,
            key: "productEnd",
            align: "center",
            width: 120,
          },
          {
          tooltip: true,
            key: "testTime",
            align: "center",
            width: 100,
          },
          {
          tooltip: true,
            key: "assembleTime",
            align: "center",
            width: 100,
          },
          {
          tooltip: true,
            key: "assemblePlanDate",
            align: "center",
            width: 160,
          },
          {
          tooltip: true,
            key: "testPlanDate",
            align: "center",
            width: 160,
          },
          {
          tooltip: true,
            key: "feedPlanDate",
            align: "center",
            width: 160,
          },

        ],
      };
    },

    mounted() {
      this.createSortable();
    },

    methods: {
      getData() {
        if (!this.currentLine || !this.currentDate) {
          return;
        }
        let param = {
          planDate: this.currentDate,
          lineName: this.currentLine,
        };
        this.scheduleLoading = true;
        this.$http.get("basic", "productionOrderSchedules/list", param)
          .then(res => {
            this.scheduledOrders = res.data || [];
            // 计算所有订单的开始时间和结束时间
            this.calculateAllOrderTimes();
            this.$http.get("basic", "productionOrderSchedules/list/person", param)
              .then(res => {
                this.scheduledPerson = res.data ? res.data.scheduledUserList.join("、") : "";
              });
          }).finally(() => {
            this.scheduleLoading = false;
          });
        // this.loadData(1);
      },

      // 时间转换函数：将时间字符串转换为分钟数
      timeToMinutes(timeStr) {
        const [hours, minutes] = timeStr.split(":").map(Number);
        return hours * 60 + minutes;
      },

      // 时间转换函数：将分钟数转换为时间字符串 (HH:MM)
      minutesToTime(minutes) {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        return `${hours.toString().padStart(2, "0")}:${mins.toString().padStart(2, "0")}`;
      },

      // 计算休息时间
      calculateBreakTime(startTime, endTime) {
        let breakTime = 0;
        // 包含10时：+10分钟
        if ((startTime <= this.timeToMinutes("10:00") && endTime >= this.timeToMinutes("10:00"))) {
          breakTime += 10;
        }
        // 包含12时到13时：+60分钟
        if ((startTime < this.timeToMinutes("13:00") && (endTime + breakTime) > this.timeToMinutes("12:00"))) {
          breakTime += 60;
        }
        // 包含15时：+10分钟
        if ((startTime <= this.timeToMinutes("15:00") && (endTime + breakTime) >= this.timeToMinutes("15:00"))) {
          breakTime += 10;
        }
        // 包含17时30分到18时：+30分钟
        if ((startTime < this.timeToMinutes("18:00") && (endTime + breakTime) > this.timeToMinutes("17:30"))) {
          breakTime += 30;
        }
        return breakTime;
      },

      // 计算所有订单的开始时间和结束时间
      calculateAllOrderTimes() {
        if (this.scheduledOrders.length === 0) return;
        // 设置第一个订单的开始时间为8:45
        let currentTime = this.timeToMinutes("08:45");
        this.scheduledOrders.forEach((order) => {
          // 设置当前订单的开始时间
          order.startTime = this.minutesToTime(currentTime);
          // 根据产线类型获取工时（小时）
          const hours = this.currentLine.includes("组装") ? (order.assembleTime || 0) : (order.testTime || 0);
          // 转换为分钟，不保留小数（向下取整）
          const workTimeMinutes = Math.ceil(hours * 60);
          // 计算初步结束时间
          let endTime = currentTime + workTimeMinutes;
          // 计算休息时间
          const breakTime = this.calculateBreakTime(currentTime, endTime);
          // 最终结束时间 = 初步结束时间 + 休息时间
          endTime += breakTime;
          // 设置当前订单的结束时间
          order.endTime = this.minutesToTime(endTime);
          // 更新下一个订单的开始时间
          currentTime = endTime;
        });
      },

      createSortable() {
        // 左侧表格拖拽配置
        let table = document.querySelector("#dragTable tbody");
        Sortable.create(table, {
          sort: false,
          group: {
            name: "shared",
            pull: "clone", // 使用true而不是clone，这样元素会被移动而不是克隆
            put: false,
          },
          onEnd: (/**Event*/ evt) => {
            evt.clone.style.display = "none";
          },
        });
        
        // 右侧表格拖拽配置
        let table2 = document.querySelector("#dragTable2 tbody");
        Sortable.create(table2, {
          group: {
            name: "shared",
          },
          onAdd: (evt) => {
            const tableData = this.$refs.viewTable.tableData || [];
            const item = tableData[evt.oldIndex];
            // 订单已存在，删除移入的DOM元素
            evt.item.remove();
            // 检查订单是否已存在
            if (this.scheduledOrders.some(order => order.productionOrderId === item.productionOrderId)) {
              this.$message.error("订单已存在");
              return;
            }
            this.$nextTick(() => {
              this.scheduledOrders.splice(evt.newIndex, 0, item);
              this.dragLoading = false;
              // 计算所有订单的开始时间和结束时间
              this.calculateAllOrderTimes();
            });
          },
          onUpdate: (evt) => {
            // 直接对原数组进行排序，避免深拷贝
            const [removedItem] = this.scheduledOrders.splice(evt.oldIndex, 1);
            this.scheduledOrders.splice(evt.newIndex, 0, removedItem);
            // 重新计算所有订单的开始时间和结束时间
            this.calculateAllOrderTimes();
          },
        });
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
        let copy = JSON.parse(JSON.stringify(this.$refs.viewTable.tableData));
        this.$refs.viewTable.tableData = [];
        this.$nextTick(() => {
          this.$refs.viewTable.tableData = copy;
        });
      },
      getSummaries({data}) {
        const sums = [];
        sums[0] = this.currentLine + "总工时";
        if (this.currentLine.includes("组装")) {
          const values = data.map(item => Number(item.assembleTime));
          if (!values.every(value => isNaN(value))) {
            sums[1] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return (prev + curr);
              } else {
                return prev;
              }
            }, 0);
            sums[1] = sums[1].toFixed(2) + " 小时";
          }
          return sums;
        } else if (this.currentLine.includes("测试")) {
          const values = data.map(item => Number(item.testTime));
          if (!values.every(value => isNaN(value))) {
            sums[1] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return (prev + curr);
              } else {
                return prev;
              }
            }, 0);
            sums[1] = sums[1].toFixed(2) + " 小时";
          }
          return sums;
        }

      },
      handleCollapse() {
        this.showAside = !this.showAside;
      },
      handleCollapse1() {
        this.showAside1 = !this.showAside1;
      },
      handleUserSelect(row) {
        if (this.scheduledPerson.some(item => item.systemUserID === row.systemUserID)) {
          return;
        }
        this.scheduledPerson.push(row);
      },
      handleTagClose(tag) {
        this.scheduledPerson.splice(this.scheduledPerson.findIndex(item => item.systemUserID === tag.systemUserID), 1);
      },
      handleRemove(row) {
        this.scheduledOrders.splice(row.$index, 1);
        this.loadData(-1);
        // 重新计算所有订单的开始时间和结束时间
        this.calculateAllOrderTimes();
      },
      handleSave() {
        if (!this.currentLine || !this.currentDate) {
          this.$message.error("请选择排产日期及排产产线");
          return;
        }
        this.submitLoading = true;
        let body = {
          orderList: this.scheduledOrders,
          scheduledPerson: this.scheduledPerson,
          planDate: this.currentDate,
          productionLine: this.currentLine,
        };
        this.$http.post("basic", "productionOrderSchedules", body)
          .then((res) => {
            if (res.success) {
              this.$message.success("计划保存成功");
              this.getData();
            }
          }).finally(() => {
            this.submitLoading = false;
          });
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };

</script>

<style scoped lang="scss">
.app-container {
  margin: 0 auto;
}

.main-content {
  display: flex;
  height: calc(100% - 80px);
}

.work-order-list {
  flex: 1;
  border-radius: 4px;
  padding: 0 5px;
  display: flex;
  flex-direction: column;
  width: 52%;
  &:not(:first-child) {
    width: calc(48% - 38px);
  }
}

.schedule-date-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}

.date-navigation {
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #303133;
  display: flex;
  align-items: center;
}
.app-container{
  padding: 15px 12px!important;
}
.work-order-right-box{
  ::v-deep .ivu-table-row{
    // display: none;
    .ivu-table-cell{
      word-break: auto-phrase;
    }
  }
}
</style>
